import type {
    TsicommonOscarappsCustomerServicesUnifiedOrderLookupOrder as UnifiedOrderLookupOrder,
    templates,
} from "@reactivated";

import { LineStatus } from "../../constants";

export type {
    TsicommonOscarappsCustomerServicesUnifiedOrderLookupLine as UnifiedOrderLookupLine,
    TsicommonOscarappsCustomerServicesUnifiedOrderLookupOrder as UnifiedOrderLookupOrder,
    TsicommonOscarappsCustomerServicesUnifiedOrderLookupOrderShipment as UnifiedOrderLookupOrderShipment,
    TsicommonOscarappsCustomerServicesUnifiedOrderLookupShippingAddress as UnifiedOrderLookupShippingAddress,
    TsicommonOscarappsCustomerServicesUnifiedOrderShipmentEvent as UnifiedOrderShipmentEvent,
} from "@reactivated";

export type OrderDataSource = UnifiedOrderLookupOrder["source"];

export type OrderPipelineConfig = NonNullable<
    templates.TrackOrderSummaryTemplate["config"]
>;
export type TRSDeliverySteps = NonNullable<
    OrderPipelineConfig["trs_delivery_steps"]
>;
export type FreightDeliverySteps = NonNullable<
    OrderPipelineConfig["freight_delivery_steps"]
>;
export type SmallPackageDeliverySteps = NonNullable<
    OrderPipelineConfig["small_package_delivery_steps"]
>;

export enum EventState {
    INCOMPLETE = "Incomplete",
    CURRENT = "Current",
    COMPLETE = "Complete",
}

export type UnifiedDeliveryEvent = {
    status: LineStatus;
    event_state: EventState;
    date: string | null;
    tracking_step_title?: string | null;
    tracking_step_copy?: string | null;
    tracking_step_copy_condensed?: string | null;
    icon_code: string | null;
};
